
initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});

function initslide() {
    $('.cstm-features-slider').slick({
    infinite: true,
    speed: 400,
    autoplay: true,
    slidesToShow: 3,
    arrows: false,
    dots:false,
    responsive: [
        {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          dots:true,
        }
      }
    ]
  });
}

function reviewSlider() {
    var swiper = new Swiper(".MreviewSlider", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".m-swiper-next",
            prevEl: ".m-swiper-prev",
        },
        breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 15 },
            840: { slidesPerView: 2, spaceBetween: 15 },
            1050: { slidesPerView: 3, spaceBetween: 15 },
            1200: { slidesPerView: 4, spaceBetween: 15 },
        },
    });
}
